<template lang="pug">
  v-container(fluid).pa-0.py-12
    v-img(height='50vh' :src='Contacto.Cuerpo.imagen').d-none.d-md-flex
      v-container
        v-row( justify='start' align='start' ).py-10.mt-10           
          p.text-uppercase.display-1.font-weight-bold.mx-12.white--text.icono-international.icono-grande( v-html='Contacto.Cuerpo.titulo').pt-7.pl-7
          
    v-row( align='center').mt-10.justify-center
      h1.font-weight-bold.my-4.mx-12.azul--text.icono-international.icono-grande( style='position: relative' v-html='Contacto.Cuerpo.sub').pt-7.pl-7.mb-10
    v-container
      Formulario_de_contacto( fondo_claro )
  

 
</template>
<script>
import { mapState } from 'vuex'
export default {
  data: ()=>({
   

    validación: true,
    model: 0,
    cargando: false,
  }),
  computed: {
    Contacto() {
      return this.$contenido.Contacto || {}
    },
    ...mapState({
      Reglas: ({Ayudas})=>Ayudas.reglas,
      contacto: ({contacto})=>contacto.Contacto,
    }),
  },
  components: {
    Formulario_de_contacto: ()=>import('../inicio/componentes/Formulario_de_contacto')
  }
}
</script>